define('app/editor/MetricPage',['require','app/app','./ReportPage','./dialogs/SaveMetricDialogView','glu/dialog','hbs!./MetricPage.hbs'],function(require) {
	'use strict';
	var App = require('app/app'),
		ReportPage = require('./ReportPage'),
		SaveMetricDialogView = require('./dialogs/SaveMetricDialogView'),
		dialog = require('glu/dialog');

	var noDesc = '(No description)';

	return ReportPage.extend({
		template: require('hbs!./MetricPage.hbs'),

		save: function(e) {
			var self = this;

			e.preventDefault();

			// Save is not allowed for internal users
			if (App.user.isInternalUser()) {
				return;
			}

			if ((this.model.isDirty() || !self.model.isSaved() || !self.model.isOwner()) && this.model.isValid() && this.model.canRenderReport()) {

				var msg = 'Please note that any changes to this metric will also reflect the changes in all monitors that use this metric. Are you sure you want to continue?';
				var caption = 'Save metric';

				dialog.confirm(msg, caption, function(ok) {
					if (ok) {
						self.model.set('saveInProgress', true, {
							silent: true
						});

						self.model.set('recentlyImported', undefined, {
							silent: true
						});

						if (self.model.getDescription() === noDesc) {
							self.model.set('description', '', {
								silent: true
							});
						}

						self.model.save().then(function() {
							self.model.set('saveInProgress', false, {
								silent: true
							});

							self.model.clean();

							self.refreshClassesAndStates();
						});
					}
				});

			}
		},

		saveAs: function(e) {
			var self = this;
			e.preventDefault();

			if (this.model.getDescription() === noDesc) {
				this.model.set('description', '', {
					silent: true
				});
			}

			if (self.model.isRunnable()) {
				this.dialog.open(new SaveMetricDialogView({
					model: this.model,
					className: 'modal-save-report',
					saveAs: true,
					noname: true,
					type: this.reportType
				}));
			}
		},

		delete: function(e) {
			var self = this;
			var cid = self.model.cid;

			e.preventDefault();

			var msg = 'Are you sure you want to delete this metric?';
			var caption = 'Delete Metric';

			dialog.confirm(msg, caption, function(ok) {
				if (ok) {
					self.model.delete().then(function() {
						App.openReports.remove(cid);
						self.model.get('domain').trigger('report:reload');
						self.navigateTo('/dashboard');
					});
				}
			});
		}
	});
});

